import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { FaFacebook } from 'react-icons/fa';
import './Signin.css';

const Signin = () => {
  const emailValue = React.useRef(null);
  const passwordValue = React.useRef(null);
  const rememberMeValue = React.useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      email: emailValue.current.value,
      password: passwordValue.current.value,
      rememberMe: rememberMeValue.current.checked,
    };

    return data;

    // haelo endpoint to submit form goes here
  };

  return (
    <section className="signin-section">
      <div className="sign-in">
        <h2 className="auth-title">Sign In</h2>
        <p className="auth-info">Stay updated on your Haelo page.</p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="email">
            Email address:
            <br />
            <input
              type="email"
              name="email"
              id="login-email"
              required="required"
              ref={emailValue}
            />
          </label>

          <label htmlFor="password">
            Password:
            <br />
            <input
              type="password"
              name="password"
              id="login-password"
              required="required"
              ref={passwordValue}
            />
          </label>

          <div className="login-check">
            <label htmlFor="remember">
              <input type="checkbox" name="remember" ref={rememberMeValue} />
              <span className="para">Remember me</span>
              <span className="check_am" />
            </label>

            <Link to="/reset-password" className="login-reset-pswd">
              <p className="para">Forgot Password?</p>
            </Link>
          </div>

          <input type="submit" value="Sign In" className="btn" />
        </form>

        <div className="auth_apps">
          <button className="auth_apps_google" type="button">
            <FontAwesomeIcon icon={faGoogle} className="fa-icon" />
            Google
          </button>

          <button className="auth_apps_facebook" type="button">
            <FaFacebook className="fa-icon" />
            Facebook
          </button>
        </div>
        <p className="auth_apps_footer">
          <Link to="/register">New to Haelo? Sign up now.</Link>
        </p>
      </div>
    </section>
  );
};

export default Signin;
